module.exports = __webpack_public_path__ + "static/jobJava-51e181ecc350c68b7b75845bc4d8ffbb.jpg";